
import { DrinkTable } from 'components/DrinkTable'


export const Part3 = ({
  tenant,
  colorMode,
}: {
  tenant: Tenant | undefined
  colorMode: 'light' | 'dark' | undefined
}) => {


  return (
    <>
    <DrinkTable lang={tenant?.lang} />
    </>
  )
}
